export const RESOURCES_NAME_LENGTH_LIMIT = {
  organization: 150,
  project: 128,
  team: 145,
  // Databases
  serverlessDatabase: 48,
  provisionedDatabase: 128,
  databaseAccess: 35,
  // Data Tools
  bucket: 100,
  scope: 251,
  collection: 251,
  documentId: 246,
  // App Services
  appRole: 128,
  appUserUsername: 239,
  appUserPassword: 128,
  // Alert
  bearerToken: 500,
  integrationUrl: 2048,
};
